// components/modals/BankCardModals/DeleteCardModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import useModalHistory from '../../../hooks/useModalHistory';

const DeleteCardModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  cardName,
  isSingle = true,
  isLoading = false 
}) => {
  useModalHistory(show, onHide, 'card-delete-modal');
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="common-modal"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="delete-confirmation">
          <div className="warning-icon mb-3">
            <i className="fas fa-exclamation-triangle"></i>
          </div>
          
          {isSingle ? (
            <p>
              Are you sure you want to delete the bank card <strong>{cardName}</strong>?
              <br />
              This action cannot be undone.
            </p>
          ) : (
            <p>
              Are you sure you want to delete the selected bank cards?
              <br />
              This action cannot be undone.
            </p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} className="modal-close-btn">
          Cancel
        </Button>
        <Button 
          variant="danger" 
          onClick={onConfirm} 
          disabled={isLoading}
          className="delete-btn"
        >
          {isLoading ? 'Deleting...' : 'Delete'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteCardModal;